import {useEffect, useState}from 'react'
import { Table,Space, App,  Flex, Modal, } from 'antd';
import ModalDel from '../../cpn/ModalDel';
import { useBnsGongNengDelMutation, useBnsGongNengListQuery } from '../../store/BnsKeJiApi';
import ModuleEdit from './ModuleEdit';
import ModuleCheck from './ModuleCheck';
import ModuleAdd from './ModuleAdd';
import { UnorderedListOutlined } from '@ant-design/icons';
function ModuleList(props) {  
    const [open, setOpen] = useState(false);
    const {message} = App.useApp();
    const [list, setList] = useState(); 
    const {data, isSuccess} = useBnsGongNengListQuery({bgn_bg_id:props.bg_id},{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if (isSuccess) {
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bgn_id:key,bgn_name,bgn_ctime,bgn_cname,bgn_content,bgn_dept_id,bgn_bg_id,bgn_dept_name,bgn_state,bgn_luyou,bgn_image,bgn_goods,bg_name,bg_id,bgn_price,bg_dept_id,bg_dept_name} = item;
                    return item = {key,bgn_name,bgn_ctime,bgn_cname,bgn_content,bgn_dept_id,bgn_bg_id,bgn_dept_name,bgn_state,bgn_luyou,bgn_image,bgn_goods,bg_name,bg_id,bgn_price,bg_dept_id,bg_dept_name}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bgn_ctime;
                    let bTimeString = b.bgn_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])  
    const columns = [
        {
            key: 'bgn_name',
            title: '模块名称',
            dataIndex: 'bgn_name', 
            render:(_,record) => {
                return <ModuleCheck bgn_id={record.key} bgn_name={record.bgn_name}/>
            }           
        }, 
        {
            key: 'bgn_content',
            title: '备注',            
            dataIndex: 'bgn_content',           
        },
        {
            key: 'num',
            title: '编号',            
            dataIndex: 'key',           
        },
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.bgn_ctime + record.bgn_cname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>  
                        <ModuleEdit 
                            bgn_id={record.key} 
                            bgn_bg_id={record.bg_id}    
                            bg_dept_name={record.bg_dept_name}   
                            bg_dept_id={record.bg_dept_id} 
                        />   
                        <ModalDel onOk={() => {
                            del({bgn_id:record.key}).then((res) => {
                                if (res.data.Status === 'success') {
                                    message.success('删除成功！')                                                                              
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('删除失败！'+res.data.Message)
                                }
                            })
                        }} />   
                                           
                    </Space>
                </>
            }
        },
    ]   
    //删除
    const [del] = useBnsGongNengDelMutation()
    return (
        <>  
            <a onClick={() => { setOpen(true) }}><UnorderedListOutlined /> 模块列表</a>
            <Modal
                open={open}
                width={1000}
                title={props.bg_name + " - 模块列表"}
                onCancel={() => { setOpen(false); }}
            >
                <Flex style={{ marginBottom: 16 }} justify='flex-end'>                    
                    <ModuleAdd bg_id={props.bg_id}  bg_name={props.bg_name}/>
                </Flex>       
                <Table 
                    columns={columns} 
                    dataSource={list} 
                    style={{marginTop:"20px"}}
                    pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}}                 
                />
            </Modal>
        </>
    )
}

export default ModuleList